import { ready } from 'shared/ready'
import $ from 'jquery'
import throttle from 'lodash/throttle'
import { trackInternalEvent } from '@rio/tracking'
import { getPageLabel } from '../constants/pages'

let previousScrollStop

function checkScrollPercentage() {
  if (!window) return

  const scrollTop = $(window).scrollTop()
  if (scrollTop === 0) return

  const pageHeight = $(document).height()
  const windowHeight = $(window).height()
  const scrollPercentage = parseInt(((scrollTop + windowHeight) / pageHeight) * 100)

  let currentScrollStop = depthOfScroll(scrollPercentage)
  if (scrollPercentage > 15 && currentScrollStop !== previousScrollStop) {
    trackInternalEvent('scroll_depth', {
      depth: currentScrollStop,
      scroll_stop_at: scrollPercentage,
      label: getPageLabel(),
    })
  }

  previousScrollStop = currentScrollStop
}

function depthOfScroll(scrollPercentage) {
  if (scrollPercentage === 100) {
    return '100%'
  } else if (scrollPercentage > 90) {
    return '90%'
  } else if (scrollPercentage > 75) {
    return '75%'
  } else if (scrollPercentage > 50) {
    return '50%'
  } else if (scrollPercentage > 25) {
    return '25%'
  } else if (scrollPercentage > 15) {
    return '15%'
  }

  return undefined
}

ready(function () {
  $(window).on('scrollend', throttle(checkScrollPercentage, 300))
})
